import React, { useContext, useEffect, useState } from "react";
import { FaCartArrowDown } from "react-icons/fa";
import { useParams } from "react-router-dom";
import { BsCartPlus } from "react-icons/bs";
import { BsCartDash } from "react-icons/bs";
import { toast } from "react-toastify";
import { AppContext } from "./Contaxt";

function Details() {
  const [product, setProduct] = useState([]);
  console.log(product);

  const [number, setNumber] = useState(0);
  const { id } = useParams();
  const [item, setItem] = useState([]);
  console.log(item);
  const { setData } = useContext(AppContext);

  const data = async (id) => {
    const responce = await fetch("https://fakestoreapi.com/products/" + id);
    const products = await responce.json();
    setProduct(products);
  };
  useEffect(() => {
    if (id) {
      data(id);
    }
  }, [id]);

  const func = () => {
    setNumber(number + 1);
  };

  const handleClick = () => {
    const prroduct = product;

    const item = localStorage.getItem("items");
    if (!item) {
      localStorage.setItem("items", JSON.stringify([prroduct]));
      setItem([prroduct]);
    } else {
      const newitem = JSON.parse(item);
      if (
        newitem.find((p) => {
          return p.id === prroduct.id;
        })
      )
        return toast.error("Item allready exist in cart!", {
          position: "top-right",
        });
      newitem.push(prroduct);
      localStorage.setItem("items", JSON.stringify(newitem));
      setItem(newitem);
      setData(newitem);
    }
    toast.success("Item added to cart", {
      position: "top-right",
    });
  };
  return (
    <>
      <div className="card mb-3 container" style={{ maxWidth: "1100px" }}>
        <div className="row g-0">
          <div className="col-md-4">
            <img
              src={product?.image}
              className="img-fluid rounded-start"
              alt="..."
            />
          </div>
          <div className="col-md-8">
            <div className="card-body">
              <h5 className="card-title">{product.category}</h5>
              <p className="card-text">{product.title}</p>
              <p className="card-text">
                <small className="text-body-secondary">
                  Price: ${product.price}
                </small>
              </p>
              <div className="btns">
                <div>
                  <h1>Quentity</h1>
                </div>
                <div>
                  <button
                    className="btnn"
                    onClick={() => {
                      if (number === 0) {
                        setNumber(0);
                      } else {
                        setNumber(number - 1);
                      }
                    }}
                  >
                    <BsCartDash />
                  </button>
                  <span className="quentity">{number}</span>
                  <button className="btnn" onClick={func}>
                    <BsCartPlus />
                  </button>
                </div>
              </div>

              <h3>Description</h3>
              <p>{product.description}</p>
              <button className="btn btn-primary" onClick={() => handleClick()}>
                Add to cart {<FaCartArrowDown />}
              </button>
            </div>
          </div>
        </div>
      </div>
      ;
    </>
  );
}

export default Details;
